export enum PdfPageOrder {
  MOBILE_FIRST = 'MobileFirst',
  DESKTOP_FIRST = 'DesktopFirst',
}
